import 'css-chunk:src/components/pages/SearchPage/SearchPage.scss';export default {
  "SearchPage": "_SearchPage_1f22n_1",
  "filters": "_filters_1f22n_8",
  "filtersOptions": "_filtersOptions_1f22n_19",
  "filtersButton": "_filtersButton_1f22n_23",
  "inviteAddressPicker": "_inviteAddressPicker_1f22n_27",
  "results": "_results_1f22n_30",
  "tabTitle": "_tabTitle_1f22n_38"
};